<template>
  <div class="tariffs">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col">
              mno
            </th>
            <th scope="col">
              tariff_name
            </th>
            <th scope="col">
              ts_add
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load" style="border:none; background-color:  transparent;">
            <td> <scale-loader /> </td>
          </tr>
          <tr v-else
            v-for="(tariff,key) in tariff_list"
            :key="key"
          >
            <td data-label="mno">{{ tariff.mno }}</td>
            <td data-label="tariff_name">{{ tariff.tariff_name }}</td>
            <td data-label="ts_add">{{ get_date(tariff.ts_add) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CommunicationManagementTariffs',
  props: [],
  data () {
    return {
      tariff_list: [],
      load: true
    }
  },

  mounted () {
    this.get_tariff_list()
  },

  methods: {
    get_tariff_list(){
      this.$http.simcard.getSimcardTariffList((response) => {
        this.tariff_list = response.data
        this.load = false
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .tariffs{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    .response_table{
      thead{
        flex: 0 1 0;
      }
      tbody{
        tr{
          transition: 0.2s;
          cursor: pointer;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .link{
        width: 50px;
      }
    }
  }
  .time_sync_simcard{
    cursor: pointer;
  }

  .link_simcard {
    cursor: pointer;
  }
 </style>
